import * as moment from 'moment-timezone';
// import * as moment from 'moment';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { ScrollService } from '../../core/scroll.service';
import { LangService } from '../../core/lang.service';
import { Subscription } from 'rxjs';
import { ChecklistStep, ChecklistStepRoute } from '../pnel-cts-checklist/model/checklist-steps';
import dayGridPlugin from '@fullcalendar/daygrid';
import { COLOR_PALETTE } from './models/colors';
import { FormGroup, FormControl } from '@angular/forms';
import { PermissionsService } from '../permissions.service';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { TEST_SESSION_DUR } from '../../constants/test-session-duration';
import { IAccountType } from '../../constants/account-types';
import { LoginGuardService } from '../../api/login-guard.service';
import { ILocation, MyTestSessionsSetupService, ITimeSlot } from '../my-test-sessions-setup.service';
import { DB_TIMEZONE } from '../../api/auth.service';

const DATE_STORE_FMT__DATE = 'YYYY-MM-DD';
const DATE_STORE_FMT__TIME = 'HH:mm';
const DATE_STORE_FMT = `${DATE_STORE_FMT__DATE} ${DATE_STORE_FMT__TIME}`;
const DATE_SENTENCE_FMT = 'dddd h:mma MMMM D, YYYY';

// interface ILocationTimeSlots {
//   locationId:number,
//   locationNumber: number,
//   locationRoom: string,
//   locationAddress: string,
//   timeSlots: ITimeSlot[],
//   entryInput?: FormGroup,
//   errorMessage?:string,
// }
interface ITimeSlotDisplay {
  __isRemoving?: boolean,
  id: number,
  locationId: number,
  count?: number,
  dateEventStr:string, // used for the calendar
  dateInput:string,
  timeFromInput: string,
  timzoneInput: string,
  timeFromDisplay?: string,
  timeToDisplay?: string,
  isOverlapping?: boolean,
  overlapsWith?: {count:number, id:number}, // count
  ignoreOverlaps?: number[]
}
type LocationId = number;
@Component({
  selector: 'view-cts-datestimes',
  templateUrl: './view-cts-datestimes.component.html',
  styleUrls: ['./view-cts-datestimes.component.scss']
})
export class ViewCtsDatestimesComponent implements OnInit, OnDestroy {

  public breadcrumb = [];

  // route
  public setupId:string;
  private routeSub:Subscription;
  private mySetupSub:Subscription;

  // load status 
  isLoaded:boolean;
  isLoadFailed:boolean;
  
  // api data
  public locations:ILocation[] = [];
  public isNoTestWindowSelected:boolean;
  public isNoLocationDefined:boolean;

  private locationInputForms:Map<LocationId, FormGroup> = new Map();
  private locationTimeSlots:Map<LocationId, ITimeSlotDisplay[]> = new Map();
  // view display models
  private newLocations = new Map();
  private savingLocations = new Map();
  // calendar
  @ViewChild('calendar') calendarComponent: FullCalendarComponent;
  calendarPlugins = [dayGridPlugin]; 
  eventTimeFormat: { // like '14:30:00'
    hour: '2-digit',
    minute: '2-digit',
    meridiem: true
  };
  events = [/* { title: 'L#1', date: '2019-11-01 09:00', backgroundColor: COLOR_PALETTE[0] }, */];

  // TO DO: remove dummy data


  // const DATE_STORE_FMT__DATE = 'YYYY-MM-DD';
  // const DATE_STORE_FMT__TIME = 'HH:mm';
  // const DATE_STORE_FMT = `${DATE_STORE_FMT__DATE} ${DATE_STORE_FMT__TIME}`;
  // const DATE_SENTENCE_FMT = 'dddd h:mma MMMM D, YYYY';

  testWindowFrom:moment.Moment;
  testWindowFromStr:string;
  testWindowTo:moment.Moment;
  testWindowToStr:string;
  hasATimeSlot:boolean;

 
  constructor(
    private loginGuard: LoginGuardService, // 
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
    private route:ActivatedRoute,
    private scrollService:ScrollService,
    private lang:LangService,
    private mySetup:MyTestSessionsSetupService,
  ) { }
  
  ngOnInit() {
    this.loginGuard.activate([IAccountType.TEST_ADMIN]);
    this.scrollService.scrollToTop();
    this.routeSub = this.route.params.subscribe(routeParams => {
      this.setupId = routeParams['setupId'];
      this.breadcrumb = this.mySetup.generateBreadcrumbs(this.setupId, 'title_date_time');
      this.initRouteView();
    });
  }

  ngOnDestroy(){

  }
  
  initRouteView(){
    let isInitialized = false;
    this.mySetupSub = this.mySetup.sub().subscribe(setupInfo => {
      if (setupInfo && !isInitialized){
        isInitialized = true;
        Promise.all([
          this.initTestWindow(),
          this.initLocations(),
        ])
        .then( () => {
          this.initLocationTimeSlots();
        })
      }
    })
  }

  initLocations(){
    return this.mySetup
      .getLocations(<any>this.setupId)
      .then(locationsData => {
        this.locations = [];
        this.locationInputForms = new Map();
        this.locationTimeSlots = new Map();
        var numberCounter = 0;
        if (locationsData.length === 0){
          this.isNoLocationDefined = true;
        }
        locationsData.forEach(location => {
          numberCounter++;
          if (!location.isRemoved){
            location.__number = numberCounter;
            const locationId = location.id;
            this.locationInputForms.set(locationId, new FormGroup({
              date: new FormControl(),
              timeFrom:  new FormControl(),
              errorMessage:  new FormControl(),
            }));
            this.locationTimeSlots.set(locationId, []);
            this.locations.push(location);
          }
        })
      })
      .catch(e => {
        this.isLoadFailed = true;
      })
  }

  initTestWindow(){
    return this.mySetup
      .getTestWindow()
      .then(testWindowInfo => {
        this.testWindowFrom = moment.tz(testWindowInfo.dateStart, DB_TIMEZONE);
        this.testWindowTo = moment.tz(testWindowInfo.dateEnd, DB_TIMEZONE);
        // console.log('testWindowInfo', testWindowInfo, this.testWindowFrom.format(DATE_SENTENCE_FMT))
        this.testWindowFromStr = this.testWindowFrom.format(DATE_SENTENCE_FMT);
        this.testWindowToStr   = this.testWindowTo.format(DATE_SENTENCE_FMT);
        // DATE_STORE_FMT__DATE
      })
      .catch(e=>{
        this.isNoTestWindowSelected = true;
      })
  }

  initLocationTimeSlots(){
    this.isLoaded = true;
    const setupId = parseInt(this.setupId);
    this.mySetup
      .getTimeSlots(setupId)
      .then( timeSlots => {
        let firstTimeSlotDisplay:ITimeSlotDisplay;
        timeSlots.forEach(timeSlot => {
          const timeSlotDisplay = this.createNewVisualEntry(timeSlot);
          if (!firstTimeSlotDisplay){
            firstTimeSlotDisplay = timeSlotDisplay
          }
        })
        this.recomputeTimeSlotNum();
        if (firstTimeSlotDisplay){
          this.navigateToCalendardate(firstTimeSlotDisplay.dateEventStr)
        }
        this.updateCalendarRender();
      })
  }

  getTestWindowChecklistRoute(){
    return this.mySetup.getCheckListRoute(ChecklistStepRoute.TestWindow, this.setupId);
  }
  getLocationChecklistRoute(){
    return this.mySetup.getCheckListRoute(ChecklistStepRoute.Location, this.setupId);
  }

  getLocationLongAddress(location:ILocation){
    return [
      this.lang.tra('cts_datestimes_room_txt')+': '+ location.room,
      location.campusBuilding,
      location.address ,
      `${location.city}, ${location.province} ${location.postalCode}`,
      location.phoneNumber,
    ].join('\n')
  }

  getLocationColor(location:ILocation){
    let i = this.locations.indexOf(location);
    return COLOR_PALETTE[i];
  }

  locForm(location:ILocation, prop?:string){
    const formGroup = this.locationInputForms.get(location.id);
    if (prop){
      return formGroup.controls[prop];
    }
    else{
      return formGroup;
    }
  }
  getLocationTimeSlots(location:ILocation){
    return this.locationTimeSlots.get(location.id);
  }

  private processAmPmTimeInput(hma:string){
    // console.log('hma', hma)
    let isPm = (hma.toLowerCase().indexOf('pm') !== -1);
    let split = hma.split(':');
    let hours = parseInt(split[0]);
    let minutes = parseInt(split[1]);
    if (isNaN(hours)){
      hours = 0;
    }
    if (isNaN(minutes)){
      minutes = 0;
    }
    if (isPm && hours < 12){
      hours += 12;
    }
    return [
      this.enforce2DigitNum(hours),
      this.enforce2DigitNum(minutes),
    ].join(':')
  }
  private enforce2DigitNum(num:number){
    if (num < 10){
      return '0'+num;
    }
    return ''+num;
  }

  getRoomCaption(){
    return this.lang.tra('cts_datestimes_room_txt');
  }

  validateInput(form:FormGroup, dateInput:string, timeFromInput:string) : {dateEventStr?:string, isValid:boolean} {
    form.controls['errorMessage'].setValue('');
    
    let isValid = true;

    const dateErrors = {isBlank: false, isInvalid: false,}
    const timeErrors = {isBlank: false, isInvalid: false,}
    if (!dateInput){
      isValid = false;
      dateErrors.isBlank = true;
      const msg = this.lang.tra('cts_datestimes_date_fmt_alert')
      form.controls['errorMessage'].setValue(msg);
    }
    if (!timeFromInput){
      isValid = false;
      timeErrors.isBlank = true;
      const msg = this.lang.tra('cts_datestimes_time_fmt_alert')
      form.controls['errorMessage'].setValue(msg);
    }

    let dateEventStr;
    if (isValid){
      const dateStr = dateInput; // no validation required
      const timeFromStr = this.processAmPmTimeInput(timeFromInput);
      // if its valid so far, check to see that it is within range
      dateEventStr = dateStr+' '+timeFromStr;
      const proposedStart = moment(dateEventStr, DATE_STORE_FMT);
      const proposedEnd = moment(proposedStart).add(TEST_SESSION_DUR, 'hours');
      const isEarly = proposedStart.isBefore(this.testWindowFrom);
      const isLate = proposedEnd.isAfter(this.testWindowTo);
      if (isEarly){
        const msg = this.lang.tra('cts_datestimes_early_alert');
        form.controls['errorMessage'].setValue(msg);
      }
      if (isLate){
        const msg = this.lang.tra('cts_datestimes_late_alert');
        form.controls['errorMessage'].setValue(msg);
      }
      if (isEarly || isLate){
        dateErrors.isInvalid = true;
        timeErrors.isInvalid = true;
        isValid = false;
      }
    }

    form.controls.date.setErrors(dateErrors);
    form.controls['timeFrom'].setErrors(timeErrors);

    return {isValid, dateEventStr};
  }
  
  addNewEntry(location:ILocation){
    const form = <FormGroup>this.locForm(location);
    const dateInput:string = form.controls['date'].value;
    const timeFromInput:string = form.controls['timeFrom'].value;
    form.disable();
    const validation = this.validateInput(form, dateInput, timeFromInput)
    if (validation.isValid){
      const dateEventStr = validation.dateEventStr;
      const proposedStart = moment(dateEventStr, DATE_STORE_FMT);
      this.createNewDbEntry(location.id, proposedStart)
        .then(timeSlot => {
          const timeSlotDisplay = this.createNewVisualEntry(timeSlot);
          this.recomputeTimeSlotNum();
          this.navigateToCalendardate(timeSlotDisplay.dateEventStr);
          form.enable();
        })
        .catch(e => {
          alert('cts_datestimes_gen_cre_err_alert');
          form.enable();
        })
    }
    if (!validation.isValid){
      form.enable();
    }
    form.markAsUntouched();
  }

  createNewDbEntry(locationId:number, proposedStart:moment.Moment){
    const timeSlot:ITimeSlot = {
      setupId: parseInt(this.setupId),
      locationId,
      dateTimeStart: proposedStart.valueOf(),
    }
    return this.mySetup
      .createTimeSlot(timeSlot)
      .then(id => {
        timeSlot.id = id;
        return timeSlot;
      })
  }

  createNewVisualEntry(timeSlot:ITimeSlot){
    const locationId = timeSlot.locationId;
    const proposedStart = moment(timeSlot.dateTimeStart);
    const proposedEnd = moment(proposedStart).add(TEST_SESSION_DUR, 'hours');
    const dateEventStr = proposedStart.format(DATE_STORE_FMT);
    const dateInput = proposedStart.format(DATE_STORE_FMT__DATE);
    const timeFromInput = proposedStart.format(DATE_STORE_FMT__TIME);
    const timeSlotDisplay:ITimeSlotDisplay = {
      id: timeSlot.id,
      locationId,
      dateEventStr,
      dateInput,
      timeFromInput,
      timzoneInput: '',
      timeFromDisplay: proposedStart.format('h:mma'),
      timeToDisplay: proposedEnd.format('h:mma'), // can go into the next day
    };
    const timeSlotDisplays = this.locationTimeSlots.get(locationId);
    timeSlotDisplays.push(timeSlotDisplay);
    return timeSlotDisplay;
  }

  navigateToCalendardate(dateEventStr:string){
    let calendarApi = this.calendarComponent.getApi();
    calendarApi.gotoDate(dateEventStr);
  }

  updateCalendarRender(){
    window.dispatchEvent(new Event('resize'));
  }

  removeTimeSlot(location:ILocation, timeSlot:ITimeSlotDisplay){
    timeSlot.__isRemoving = true;
    this.mySetup
      .removeTimeSlot(timeSlot.id)
      .then(res => {
        const timeSlots = this.getLocationTimeSlots(location);
        let i = timeSlots.indexOf(timeSlot);
        if (i !== -1){
          timeSlots.splice(i, 1);
          this.recomputeTimeSlotNum();
        }
      })
      .catch(e => {
        timeSlot.__isRemoving = false;
        const msg = this.lang.tra('cts_datestimes_gen_rm_err_alert')
        alert(msg);
      })
  }

  dismissOverlap(timeSlot:ITimeSlotDisplay){
    if (!timeSlot.ignoreOverlaps){
      timeSlot.ignoreOverlaps = [];
    }
    if (timeSlot.overlapsWith){
      timeSlot.ignoreOverlaps.push(timeSlot.overlapsWith.id)
    }
    this.recomputeTimeSlotNum();
  }

  recomputeTimeSlotNum(){
    let count = 0;
    this.events = []; 
    const previousTimesSlots:{m:moment.Moment, timeSlot: ITimeSlotDisplay}[] = []
    this.locations.forEach(location => {
      const locTimeSlots = this.locationTimeSlots.get(location.id);
      // sort by date
      const locTimeSlotsSorted = locTimeSlots.sort( (a,b) => {
        if (a.dateEventStr === b.dateEventStr){ return 0 }
        else if (a.dateEventStr > b.dateEventStr){ return 1 }
        return - 1;
      })
      this.locationTimeSlots.set(location.id, locTimeSlotsSorted);
      // iterate through each time slot
      locTimeSlotsSorted.forEach(timeSlot =>{
        count ++;
        timeSlot.count = count;
        // reset validation
        timeSlot.isOverlapping = false;
        timeSlot.overlapsWith = null;
        // add to events array for calendar component
        this.events.push({ 
          title: this.getRoomCaption() +' '+ location.room, 
          date: timeSlot.dateEventStr, 
          backgroundColor: this.getLocationColor(location) 
        });
        // create moment object for date comparison
        const m = moment(timeSlot.dateEventStr, DATE_STORE_FMT);
        const mLower = moment(m).add(-(TEST_SESSION_DUR+1), 'hours');
        const mUpper = moment(m).add((TEST_SESSION_DUR+1), 'hours');
        if (!timeSlot.ignoreOverlaps){
          timeSlot.ignoreOverlaps = [];
        }
        previousTimesSlots.forEach(prev =>{
          if ( mLower.isBefore(prev.m) && mUpper.isAfter(prev.m) ){
            if (timeSlot.ignoreOverlaps.indexOf(prev.timeSlot.id) === -1 ){
              prev.timeSlot.isOverlapping = true;
              timeSlot.isOverlapping = true;
              timeSlot.overlapsWith = {count: prev.timeSlot.count, id: prev.timeSlot.id};
            }
          }
        })
        previousTimesSlots.push({m, timeSlot});
      })
    })
    this.hasATimeSlot = (count > 0)
  }

  isInputError(control:FormControl){
    if (control.untouched && (control.hasError('isBlank') || control.hasError('isInvalid'))){
      return true;
    }
  }

  getPaletteColor(i:number){
    return COLOR_PALETTE[i];
  }

  handleDateClick(arg) { // handler method
    alert(arg.dateStr);
  }

  getCurrentStepId(){
    return ChecklistStep.DateAndTime
  }

  isReadyToContinue(){
    return this.mySetup.getChecklistStepState(ChecklistStepRoute.DateAndTime)
  }

  gotoNextRoute(){
    const nextRouteSuffix = ChecklistStepRoute.Accommodations;
    let breadcrumb = this.breadcrumbsService.TESTADMIN_CREATE_TEST_SESSION(this.setupId, nextRouteSuffix);
    this.router.navigate([ breadcrumb.route ]);
  }

}
